import { createAssignmentWidgetSlice } from "../createAssignmentWidgetSlice";
import { fetchProposalAssignment } from "./actions";

const proposalAssignmentSlice = createAssignmentWidgetSlice({
  name: "proposalAssignment",
  fetchThunk: fetchProposalAssignment,
  defaultError: "Failed to load proposal assignment",
});

export default proposalAssignmentSlice.reducer;
